import { Document } from './Document';

export class LeakEntryView {
  hashId: string = '';
  index: number = 0;
  location: string = '';
  leakRepaired: boolean = true;
  documents: Document[];
}
